export const GET_DEPRECIATION_REPORT = 'GET_DEPRECIATION_REPORT';
export const GET_DEPRECIATION_REPORT_PAGINATED = 'GET_DEPRECIATION_REPORT_PAGINATED';
export const SET_DEPRECIATION_REPORT_FILTERS = 'SET_DEPRECIATION_REPORT_FILTERS';
export const SET_DEPRECIATION_REPORT_PAGINATION = 'SET_DEPRECIATION_REPORT_PAGINATION';
export const RESET_DEPRECIATION_REPORT = 'RESET_DEPRECIATION_REPORT';
export const GET_DEPRECIATION_REPORT_XLSX = 'GET_DEPRECIATION_REPORT_XLSX';



// WEBPACK FOOTER //
// src/containers/reports/constants.js